'use client';

import { Button } from '@ahafood/ui/components/button';

interface ChatSuggestionsProps {
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
  isLoading?: boolean;
}

export function ChatSuggestions({
  suggestions,
  onSuggestionClick,
  isLoading = false,
}: ChatSuggestionsProps) {
  return (
    // <div className="p-4">

    <div className="flex gap-3 pt-4 pb-2 px-4 overflow-x-auto scrollbar-hide">
      {suggestions.map((suggestion, i) => (
        <Button
          key={i}
          variant="outline"
          className="group size-auto shrink-0 cursor-pointer rounded-full border border-neutral-15 bg-white px-4 py-2 shadow-sm transition-all hover:-translate-y-0.5 hover:border-primary-30 hover:bg-primary-10/40 hover:shadow-md md:bg-white/60"
          onClick={() => onSuggestionClick(suggestion)}
          disabled={isLoading}
        >
          <span className="line-clamp-1 text-left text-sm font-medium text-neutral-80 transition-colors group-hover:text-primary-60">
            {suggestion}
          </span>
        </Button>
      ))}
    </div>
    // </div>
  );
}
